module.exports = __webpack_public_path__ + "img/PXL_20230525_095203405.7f69b11e.jpg";